import React from 'react';
import Proptypes from 'prop-types';
import { formatCurrency } from '../../lib/helpers/formatters';

import './BalanceCont.scss';

function BalanceCont(props) {
  const displayValue = props.isCurrency ? formatCurrency(props.value) : props.value;
  const className = props.isCurrency ? 'balance-cont balance-cont--currency' : 'balance-cont';

  return (
    <div className={className}>
      <h5>
        {props.title}
      </h5>
      <hr />
      <p>
        {displayValue}<br />
        {props.unit && <i>{props.unit}</i>}
      </p>
    </div>
  );
}

BalanceCont.propTypes = {
  title: Proptypes.string.isRequired,
  value: Proptypes.number.isRequired,
  unit: Proptypes.string,
  isCurrency: Proptypes.bool,
};

BalanceCont.defaultProps = {
  isCurrency: false,
  unit: '',
};

export default BalanceCont;